import { Version } from '@angular/core';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AbonosComponent } from './abonos/abonos.component';
import { AccesoGuardGuard } from './acceso-guard.guard';
import { ClienteComponent } from './cliente/cliente.component';
import { ComprasComponent } from './compras/compras/compras.component';


// Import Containers
import { DefaultLayoutComponent } from './containers';
import { CuentasxcobrarService } from './cuentasxcobrar.service';
import { CuentasxcobrarComponent } from './cuentasxcobrar/cuentasxcobrar.component';
import { DocumentoelectronicosComponent } from './documentoelectronicos/documentoelectronicos.component';
import { EmisorComponent } from './emisor/emisor.component';
import { EnularFacturaComponent } from './enular-factura/enular-factura.component';
import { FacturacionComponent } from './facturacion/facturacion.component';
import { FormaPagoComponent } from './forma-pago/forma-pago.component';
import { GrupoComponent } from './grupo/grupo.component';
import { IventarioFisicoComponent } from './iventario-fisico/iventario-fisico.component';

import { KardexComponent } from './kardex/kardex/kardex.component';
import { ListaComprasComponent } from './lista-compras/lista-compras.component';
import { Producto } from './producto';
import { ProductoComponent } from './producto/producto.component';
import { ProveedorComponent } from './proveedor/proveedor/proveedor.component';
import { InventarioComponent } from './reporte/inventario/inventario.component';
import { VentaProdComponent } from './reporte/venta-prod/venta-prod.component';
import { VentasMesComponent } from './reporte/ventas-mes/ventas-mes.component';
import { VentasComponent } from './reporte/ventas/ventas.component';
import { UtilidadComponent } from './reporte/utilidad/utilidad.component';
import { UnidadComponent } from './unidades/unidad/unidad.component';
import { VercomprasComponent } from './vercompras/vercompras.component';


import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { VendedorComponent } from './vendedor/vendedor.component';
import { PedidosComponent } from './pedidos/pedidos.component';
import { VerpedidoComponent } from './verpedido/verpedido.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { EgresoComponent } from './egreso/egreso.component';
import { EmpleadoComponent } from './empleado/empleado.component';
import { FacturaTouchComponent } from './factura-touch/factura-touch.component';
import { RetencionVentasComponent } from './retencion-ventas/retencion-ventas.component';
import { CuentasxCobrarComponent } from './reporte/cuentasx-cobrar/cuentasx-cobrar.component';
import { ClientesProveedorComponent } from './reporte/clientes-proveedor/clientes-proveedor.component';
import { FacturaXlsComponent } from './factura-xls/factura-xls.component';
import { RetencionComprasComponent } from './retencion-compras/retencion-compras.component';
import { CaducidadComponent } from './reporte/caducidad/caducidad.component';
import { CajaComponent } from './caja/caja.component';
import { ReporteCajaComponent } from './reporte-caja/reporte-caja.component';
import { ReimprimirComponent } from './reimprimir/reimprimir.component';
import { CanalesComponent } from './canales/canales.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
    canActivate: [AccesoGuardGuard]
  },
  {
    path: '404',
    canActivate: [AccesoGuardGuard],
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    canActivate: [AccesoGuardGuard],
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AccesoGuardGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      },
    
     
      {
        path: 'emisor', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: EmisorComponent
        ,
        data: {
          permissions: {
            only: ['Administrador'],
            //redirectTo: '/unidades'
          }
        }
      },
      
      {
        path: 'productos', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: ProductoComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'unidades', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: UnidadComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      },
      
      {
        path: 'clientes', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: ClienteComponent,
        data: {
          permissions: {
              only: ['Administrador','CAJAB'],
            //redirectTo: '/unidades'
          }
        }
      },
    
      {
        path: 'reporteCaja', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: ReporteCajaComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'proveedor', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: ProveedorComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'formaPago', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: FormaPagoComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'grupos', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: GrupoComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      },
      
      {
        path: 'facturar', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: FacturacionComponent,
        data: {
          permissions: {
            only: ['Administrador','CAJA',],
            //redirectTo: '/unidades'
          }
        }
      },

      {
        path: 'facturarTouch', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: FacturaTouchComponent,
        data: {
          permissions: {
            only: ['Administrador','CAJA','CAJAB'],
            //redirectTo: '/unidades'
          }
        }
      },

      {
        path: 'RetencionxVenta', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: RetencionVentasComponent,
        data: {
          permissions: {
            only: ['Administrador','CAJA'],
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'caja', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: CajaComponent,
        data: {
          permissions: {
            only: ['Administrador','CAJA','CAJAB'],
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'ReporteCxC', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: CuentasxCobrarComponent,
        data: {
          permissions: {
            only: ['Administrador'],
            //redirectTo: '/unidades'
          }
        }
      },

  
      {
        path: 'ReporteClienteProveedor', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: ClientesProveedorComponent,
        data: {
          permissions: {
            only: ['Administrador'],
            //redirectTo: '/unidades'
          }
        }
      },
     
      {
        path: 'caducidad', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: CaducidadComponent,
        data: {
          permissions: {
            only: ['Administrador'],
            //redirectTo: '/unidades'
          }
        }
      },

      
      {
        path: 'compras', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: ListaComprasComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'egresos', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: EgresoComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'detallecompras', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: ComprasComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'proveedor', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: ProveedorComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }

      ,
      {
        path: 'vercompras', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: VercomprasComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'retencionCompras', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: RetencionComprasComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'facturaxls', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: FacturaXlsComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
     
      ,
      {
        path: 'verpedido', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: VerpedidoComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'cxc', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: CuentasxcobrarComponent,
        data: {
          permissions: {
            only: ['Administrador','CAJA'],
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'abonos', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: AbonosComponent,
        data: {
          permissions: {
            only: ['Administrador'],
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'facturarTouch', canActivate: [AccesoGuardGuard],
        component: FacturaTouchComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      },
       {
        path: 'canales', canActivate: [AccesoGuardGuard],
        component: CanalesComponent,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      },
      {
        path: 'anularv', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: EnularFacturaComponent,
        data: {
          permissions: {
             only: ['Administrador'],
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'reimprimir',  canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: ReimprimirComponent,
        data: {
          permissions: {
              only: ['Administrador','CAJA','CAJAB'],
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'kardex', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: KardexComponent,
        data: {
          permissions: {
            only: ['Administrador'],
            //redirectTo: '/unidades'
          }
        }
      } ,
      {
        path: 'inventario', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: InventarioComponent,
        
        data: {
          permissions: {
             only: ['Administrador'],
            //redirectTo: '/unidades'
          }
        }
      }

      ,
      {
        path: 'vendedor', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: VendedorComponent
        ,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }

      ,
      {
        path: 'empleado', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: EmpleadoComponent
        ,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'pedido', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: PedidosComponent
        ,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }



      ,
      {
        path: 'fisico', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: IventarioFisicoComponent
        ,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }

      ,
      {
        path: 'ventaCli', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: VentasComponent
        ,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'ventaMes', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: VentasMesComponent
        ,
        data: {
          permissions: {
            only: ['Administrador'],
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'ventaProd', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: VentaProdComponent
        ,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'electronicos', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: DocumentoelectronicosComponent
        ,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
      ,
      {
        path: 'utilidad', canLoad: [AccesoGuardGuard], canActivate: [NgxPermissionsGuard],
        component: UtilidadComponent
        ,
        data: {
          permissions: {
            only: 'Administrador',
            //redirectTo: '/unidades'
          }
        }
      }
      
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
